// Partially pulled from react-hammerjs https://github.com/JedWatson/react-hammerjs
import React, { Component } from "react";
import { autobind } from "core-decorators";
import Hammer from "hammerjs";
import PropTypes from "prop-types";
import propagating from "propagating-hammerjs";

const handlerMap = {
  onTap: "tap",
};

function updateHammerInstance(hammerInstance, props) {
  if (props.options) {
    Object.keys(props.options).forEach((option) => {
      if (option === "recognizers") {
        Object.keys(props.options.recognizers).forEach((gesture) => {
          const recognizer = hammerInstance.get(gesture);
          recognizer.set(props.options.recognizers[gesture]);
        });
      } else {
        hammerInstance.set({
          [option]: props.options[option],
        });
      }
    });
  }

  Object.keys(props).forEach((prop) => {
    const event = handlerMap[prop];
    if (event) {
      hammerInstance.off(event);
      hammerInstance.on(event, props[prop]);
    }
  });
}

export default class HammerContainer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    options: PropTypes.object,
  };

  componentDidUpdate() {
    if (this.hammer) {
      updateHammerInstance(this.hammer, this.props);
    }
  }

  componentWillUnmount() {
    this.unloadHammer();
  }

  unloadHammer() {
    if (this.hammer) {
      this.hammer.stop();
      this.hammer.destroy();
    }
    this.hammer = null;
  }

  @autobind
  handleChildRef(domElement) {
    if (domElement) {
      this.hammer = propagating(new Hammer(domElement));
      updateHammerInstance(this.hammer, this.props);
    } else {
      this.unloadHammer();
    }
  }

  render() {
    // adding a ref to the child allows getting the child root element
    const props = {
      ref: this.handleChildRef,
    };

    // Reuse the child provided
    // This makes it flexible to use whatever element is wanted (div, ul, etc)
    return React.cloneElement(React.Children.only(this.props.children), props);
  }
}

Object.keys(handlerMap).forEach((key) => {
  HammerContainer.propTypes[key] = PropTypes.func;
});
